import React, { useEffect } from "react";
import { guidelinePageTabs, pbGuidelinePageTabs } from "./guidelineTabs";
import styles from "./overview/GuidelineOverview.module.scss";
import { useLocation } from "react-router-dom";
import { isPregnancyAndBreastfeedingPage } from "../../utils/isPregnancyAndBreastfeedingPage";
import { isNullOrEmpty } from "../../utils/isNullOrEmpty";

const TabGroup = React.lazy(() => import("../../components/TabGroup/TabGroup"));

const GuidelineLandingPage = () => {
  const { pathname } = useLocation();
  const [tabs, setTabs] = React.useState([]);

  useEffect(() => {
    if (isPregnancyAndBreastfeedingPage(pathname)) {
      setTabs(pbGuidelinePageTabs);
    } else {
      setTabs(guidelinePageTabs);
    }
  }, [pathname]);

  return (
    <div className={styles.tabs}>
      {!isNullOrEmpty(tabs) && (
        <TabGroup
          key={tabs.map((t) => t.id).join("-")}
          tabs={tabs}
          defaultId={tabs[0].id}
          alignLeft={true}
          borderBottom={true}
        />
      )}
    </div>
  );
};

export default GuidelineLandingPage;